export type NaveganteTabOption = 'lineup' | 'explore' | 'offers' | 'messages' | 'information';

export interface NaveganteAppConfig {
  NO_RESULTS_TEXT: string;
  NO_FAVORITES_TEXT: string;
  LINEUP_LABEL: string;
  EXPLORE_LABEL: string;
  OFFERS_LABEL: string;
  MESSAGES_LABEL: string;
  INFORMATION_LABEL: string;
  FAVORITES_LABEL: string;
  TODAY_LABEL: string;
  TOMORROW_LABEL: string;
  TRENDING_LABEL: string;
  TRENDING_ICON: string;
  UPCOMING_LABEL: string;
  OPEN_NOW_LABEL: string;
  VENUE_OPEN_LABEL: string;
  VENUE_CLOSED_LABEL: string;
  FUTURE_DAY_CAP: number;
  LANGUAGES: Array<{ key: string; label: string }>;
}

export const DEFAULT_APP_CONFIG: NaveganteAppConfig = {
  NO_RESULTS_TEXT: 'No results found',
  NO_FAVORITES_TEXT: 'No favorites added',
  LINEUP_LABEL: 'Lineup',
  EXPLORE_LABEL: 'Explore',
  OFFERS_LABEL: 'Offers',
  MESSAGES_LABEL: 'Messages',
  INFORMATION_LABEL: 'Information',
  FAVORITES_LABEL: 'Favorites',
  TODAY_LABEL: 'Today',
  TOMORROW_LABEL: 'Tomorrow',
  TRENDING_LABEL: 'Trending',
  TRENDING_ICON: 'fire',
  UPCOMING_LABEL: 'Upcoming',
  OPEN_NOW_LABEL: 'Open Now',
  VENUE_OPEN_LABEL: 'Open',
  VENUE_CLOSED_LABEL: 'Closed',
  FUTURE_DAY_CAP: 3,
  LANGUAGES: [],
};
